import type { Project } from "@akhshy/types";
import { Link } from "react-router-dom";

/**
 * Returns the internal browser path for a link, or null if it's external.
 * Converts hash links (`#ritual`, `https://akhshy.dev/#ritual`) and bare
 * paths (`/ritual`) into router paths; `#home` becomes `/`.
 */
function toInternalPath(url: string): string | null {
  const hashMatch = url.match(/^(?:https?:\/\/akhshy\.dev\/?)?#(.*)$/);
  if (hashMatch) {
    const slug = hashMatch[1];
    return !slug || slug === "home" ? "/" : `/${slug}`;
  }
  if (url.startsWith("/")) return url;
  return null;
}

export function ProjectCard({ project }: { project: Project }) {
  return (
    <div className="proj">
      <span className="proj-tag">{project.tag}</span>
      <h4>{project.name}</h4>
      <p>{project.description}</p>
      {project.markerNote && <p className="marker-note">{project.markerNote}</p>}
      {project.links.length > 0 && (
        <div className="proj-links">
          {project.links.map((link, i) => {
            const internal = toInternalPath(link.url);
            return internal ? (
              <Link key={i} to={internal}>
                {link.label}
              </Link>
            ) : (
              <a key={i} href={link.url} target="_blank" rel="noopener">
                {link.label}
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}
